// common
export const RESET_STATE = 'reset'

// --

// licencereport
export const SET_CULTURE_DIRTY = 'setDirty'
export const SET_CULTURE = 'set'
